module.exports = __webpack_public_path__ + "img/public/SiteIcons/editWrite.svg?c3a04ef2";